// ==============================|| MENU ITEMS - LOCATIONS ||============================== //

import { PERMISSIONS } from "../permissions/permissions";

// ==============================|| MENU ITEMS - LOCATIONS ||============================== //
const locationsComponents = {
  id: 'locations-group',
  type: 'group',
  children: [
    {
      id: 'location-collapse',
      title: 'menu.locations',
      type: 'collapse',
      icon: 'ph ph-map-pin',
      children: [
        {
          id: 'view-locationss',
          title: 'menu.locations',
          type: 'item',
          url: '/location',
          permission: PERMISSIONS.LOCATION.VIEW_ALL,
        },
        {
          id: 'add-location-item',
          title: 'menu.addNewLocation',
          type: 'item',
          url: '/location/add-location',
          breadcrumbs: true,
          hideInMenu: true,
          permission: PERMISSIONS.LOCATION.CREATE,
        },
{
          id: 'location-detail',
          title: 'menu.loactionDetail',
          type: 'item',
          url: '/admin/location/view-location',
          matchPath: '/admin/location/view-location/:id',
          breadcrumbs: true,
          hideInMenu: true,
          permission: PERMISSIONS.LOCATION.VIEW_LOCATION,
        },
        {
          id: 'edit-location',
          title: 'menu.editLocation',
          type: 'item',
          url: '/location/:id/edit-location',
          breadcrumbs: true,
          hideInMenu: true ,
          permission: PERMISSIONS.LOCATION.DELETE,
        },
        {
          id: 'view-location',
          title: 'menu.viewLocation',
          type: 'item',
          url: '/location/current-location',
          // breadcrumbs: true,
          // hideInMenu: true ,
          permission: PERMISSIONS.LOCATION.VIEW,
        }
      ]
    }
  ]
};

export default locationsComponents;